const RUBRIQUES = [
  {
    titre: "Chez Perceval",
    lignes: [
      ["compte", "Compte d'accès", "user"],
      ["comptesSansAcces", "Demandeurs sans compte", "user-clock"],
      ["fichesAEffacer", "Fiches prospect", "id-card"],
      ["demandesEntreprise", "Demandes de devis entreprise", "file-alt"],
      ["leadsEntreprise", "Leads entreprise", "bullseye"],
      ["demandesDommagesOuvrage", "Demandes dommages-ouvrage", "hard-hat"],
      ["paiementsSansEncaissement", "Paiements jamais encaissés", "credit-card"],
      ["documents", "Documents et pièces jointes", "paperclip"],
    ],
  },
  {
    titre: "Chez les partenaires",
    lignes: [
      ["demandesAuto", "Demandes d'assurance auto", "car"],
      ["contactEmailing", "Contact dans l'outil d'emailing", "envelope"],
      ["clientPaiementEnLigne", "Compte chez le prestataire de paiement", "wallet"],
    ],
  },
];

const STATUTS_DEFINITIFS = ["terminee", "refusee", "abandonnee"];

const PRESENTATIONS = {
  terminee: { ton: "succes", icone: "check-circle" },
  faite: { ton: "succes", icone: "check-circle" },
  "en-cours": { ton: "encours", icone: "sync-alt" },
  "en-attente": { ton: "neutre", icone: "clock" },
  "a-faire": { ton: "neutre", icone: "circle", prefixe: "far" },
  "en-echec": { ton: "echec", icone: "times-circle" },
  echouee: { ton: "echec", icone: "times-circle" },
  refusee: { ton: "alerte", icone: "ban" },
  abandonnee: { ton: "neutre", icone: "minus-circle" },
};

const DELAI_AVANT_BLOCAGE_MS = 2 * 60 * 1000;

export function etatApercu(apercu) {
  if (!apercu.effacable) return "refuse";
  return apercu.aucuneDonnee ? "vide" : "effacable";
}

export function groupesApercu(apercu) {
  return RUBRIQUES.map(({ titre, lignes }) => ({
    titre,
    lignes: lignes
      .filter(([cle]) => apercu[cle] === true || apercu[cle] > 0)
      .map(([cle, libelle, icone]) => ({ cle, libelle, icone, valeur: apercu[cle] === true ? null : apercu[cle] })),
  })).filter((groupe) => groupe.lignes.length > 0);
}

export const confirmationValide = (saisie, email) =>
  saisie.trim().toLowerCase() !== "" && saisie.trim().toLowerCase() === email.trim().toLowerCase();

export const presentationStatut = (statut) => ({ prefixe: "fa", ...(PRESENTATIONS[statut] || PRESENTATIONS["a-faire"]) });

export const estDefinitif = (statut) => STATUTS_DEFINITIFS.includes(statut);

export const doitSuivre = (statut) => statut === "en-attente" || statut === "en-cours";

const derniereProgression = (demande) =>
  Math.max(
    new Date(demande.demandeeLe).getTime(),
    ...(demande.cibles || []).filter((cible) => cible.traiteeLe).map((cible) => new Date(cible.traiteeLe).getTime())
  );

export function traitementBloque(demande, maintenant = new Date()) {
  return doitSuivre(demande.statut.id) && maintenant - derniereProgression(demande) > DELAI_AVANT_BLOCAGE_MS;
}

export function progression(demande) {
  return {
    faites: demande.cibles.filter((cible) => cible.statut.id === "faite").length,
    total: demande.cibles.length,
  };
}

export function resultatCible(cible, statutDemande) {
  if (cible.statut.id === "echouee") return cible.erreur;
  if (cible.statut.id === "faite") {
    if (!cible.nombreElements) return "Rien à effacer";
    return cible.nombreElements > 1
      ? `${cible.nombreElements} éléments effacés`
      : "1 élément effacé";
  }
  return doitSuivre(statutDemande) ? "En attente" : "Non traitée";
}

export function avecDemandeAJour(registre, demande) {
  if (!registre.data.some((ligne) => ligne.id === demande.id)) return registre;
  return { ...registre, data: registre.data.map((ligne) => (ligne.id === demande.id ? demande : ligne)) };
}

export function formaterDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
